"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _remarkGfm = _interopRequireDefault(require("remark-gfm"));
var _rehypeRaw = _interopRequireDefault(require("rehype-raw"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// We’re leveraging EBI Visual Framework (i.e. Foundation) to make the component functional. See this package’s
// html/index.html for a working example with all the necessary boilerplate.
// For vanilla HTML see version 1 of this component, which tracked visibility in its state.
var AtlasInformationBanner = function AtlasInformationBanner(_ref) {
  var motd = _ref.motd;
  return _typeof(motd) === "string" && motd.trim().length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "callout margin-bottom-none",
    "data-closable": "",
    role: "complementary"
  }, /*#__PURE__*/_react["default"].createElement(_reactMarkdown["default"], {
    remarkPlugins: [_remarkGfm["default"]],
    rehypePlugins: [_rehypeRaw["default"]]
  }, motd), /*#__PURE__*/_react["default"].createElement("button", {
    className: "close-button",
    "aria-label": "Dismiss information banner",
    type: "button",
    "data-close": ""
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": true
  }, "\xD7"))) : null;
};
AtlasInformationBanner.propTypes = {
  motd: _propTypes["default"].string
};
AtlasInformationBanner.defaultProps = {
  motd: ""
};
var _default = exports["default"] = AtlasInformationBanner;